/** @jsx jsx */
import { jsx } from "theme-ui"
import Link from "./link"

import PropTypes from "prop-types"

const LanguageSwitcher = ({ currentLanguage, currentURL, seoLinks }) => {
  if (currentLanguage === "en") {
    return (
      <span data-cy-identifier="language-switch">
        <strong>En</strong> |{" "}
        <Link
          sx={{ color: "text", textDecoration: "none" }}
          to={currentURL ? currentURL.substr(3) : currentURL}
          seoLinks={seoLinks}
          language={"de"}
        >
          De
        </Link>
      </span>
    )
  } else {
    return (
      <span data-cy-identifier="language-switch">
        <strong>De</strong> |{" "}
        <Link
          sx={{ color: "text", textDecoration: "none" }}
          to={currentURL}
          seoLinks={seoLinks}
          language={"en"}
        >
          En
        </Link>
      </span>
    )
  }
}

LanguageSwitcher.propTypes = {
  currentLanguage: PropTypes.oneOf(["de", "en"]).isRequired,
  currentURL: PropTypes.string.isRequired,
  seoLinks: PropTypes.object.isRequired,
}

LanguageSwitcher.defaultProps = {
  currentURL: "",
  currentLanguage: "de",
  seoLinks: {},
}

export default LanguageSwitcher
